<script setup lang="ts">
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

defineProps<{
  title?: string;
}>();

const emit = defineEmits<{
  (e: "back"): void;
}>();
</script>

<template>
  <div class="field-header bg-blue-gradient">
    <button class="btn-back" @click="emit('back')">
      <PhosphorIcon name="arrow-left" :size="22" weight="bold" />
    </button>
    <div class="header-title">
      <span v-if="title">{{ title }}</span
      ><slot v-else name="title" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.field-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 16px;
  height: 60px;
  color: white;
  flex-shrink: 0;
}

.btn-back {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
  }
}

.header-title {
  flex: 1;
  font-size: 18px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
